export default async ({ store }) => {
  const { default: createPersistedState } = await import('vuex-persistedstate')
  const options = { key: 'searches', paths: ['searches'] }

  createPersistedState(options)(store)
}
